import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { QuestionnaireEditModule } from "@/modules/newCommunity/pages/operationTools/dynimicStore";
let fillInTable = class fillInTable extends Vue {
  constructor() {
    super(...arguments);
    this.newArr = [];
    this.tableData = [];
    this.columns = [];
  }
  // eslint-disable-next-line
  watchIndex() {}
  dataChage(value) {
    this.zItem = value;
    this.compuedColumn();
  }
  compuedColumn() {
    let rowData = this.item.jsonConfig.rowList || [];
    let columnData = this.item.jsonConfig.columnList || [];
    let computedColumnData = [{
      field: "fieldZero",
      key: "fieldZero",
      label: this.item.jsonConfig.crossCellText || "",
      align: "center",
      width: 100,
      fixed: "left"
    }];
    columnData.forEach((col, index) => {
      let column = {
        field: "field" + index,
        key: "field" + index,
        label: col.content,
        align: "left",
        width: 130,
        fixed: ""
      };
      computedColumnData.push(column);
    });
    // console.log("computedColumnData", columnData, computedColumnData);
    // console.log("rowData", rowData);
    let computedTableData = [];
    for (let index = 0; index < rowData.length; index++) {
      let data = {};
      for (const item of computedColumnData) {
        if (this.viewMode == "ANSWERREVIEW" && this.item.answer) {
          data[item.field] = this.item.answer[index][item.field];
        } else {
          data[item.field] = "";
        }
      }
      data.fieldZero = rowData[index].content;
      computedTableData.push(data);
    }
    // console.log("computedTableData", computedTableData);
    this.tableData = computedTableData;
    this.columns = computedColumnData;
  }
  get questionnaireType() {
    return this.businessType || QuestionnaireEditModule.questionnaireType;
  }
};
__decorate([Prop({
  type: String,
  default: "EDIT"
})], fillInTable.prototype, "viewMode", void 0);
__decorate([Prop({
  type: Number,
  default: 0
})], fillInTable.prototype, "zIndex", void 0);
__decorate([Prop({
  type: Boolean,
  default: true
})], fillInTable.prototype, "showScore", void 0);
__decorate([Prop({
  type: String,
  default: ""
})], fillInTable.prototype, "businessType", void 0);
__decorate([Prop({
  type: Boolean,
  default: true
})], fillInTable.prototype, "Required", void 0);
__decorate([Watch("zIndex", {
  immediate: true
})], fillInTable.prototype, "watchIndex", null);
__decorate([Prop({
  type: Object,
  default: {}
})], fillInTable.prototype, "item", void 0);
__decorate([Watch("item", {
  immediate: true,
  deep: true
})], fillInTable.prototype, "dataChage", null);
fillInTable = __decorate([Component({
  name: "fillInTable"
})], fillInTable);
export default fillInTable;